import React from "react";

export const Grid = () => {
  const size = 27;
  
  return (
    <svg
      width="0"
      height="0"
      style={{
        position: "absolute",
        marginLeft: "-100%",
      }}
    >
      <defs>
        <pattern
          id="grid"
          width={`${size}`}
          height={`${size}`}
          patternUnits="userSpaceOnUse"
          // patternTransform={`translate(0, ${size * 2})`}
        >
          {/* GRID PATTERN: M ${size} 0 L 0 0 0 ${size} */}
          <path
            d={`M 0 ${size} L ${size} ${size}`}
            fill="none"
            stroke="rgb(127, 127, 127, 0.65)"
            strokeWidth="1"
            opacity="0.3"
          />
        </pattern>
      </defs>
    </svg>
  );
};
